// import components
import { styled, Box } from '@mui/material';

export const StyledSpeechBubbleWrapperBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'showAnimatedSpeechBubble'
})<{ showAnimatedSpeechBubble?: boolean }>(
  ({ theme, showAnimatedSpeechBubble }) => ({
    position: 'absolute',
    zIndex: 1000,
    bottom: theme.spacing(25),
    right: theme.spacing(6.25),
    filter: 'drop-shadow(0px 0px 6px rgba(0, 0, 0, 0.1))',
    transform: showAnimatedSpeechBubble ? 'scale(1)' : 'scale(0.8)',
    opacity: showAnimatedSpeechBubble ? 1 : 0,
    transition:
      'transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.4s ease'
  })
);
export const StyledSpeechBubbleBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  color: 'text.primary',
  padding: theme.spacing(1, 4),
  borderRadius: theme.shape.borderRadius,
  fontSize: theme.typography.body1.fontSize,
  zIndex: 1000
}));

export const StyledSpeechBubbleTailBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '100%',
  right: theme.spacing(5),
  width: 0,
  height: 0,
  borderLeft: '8px solid transparent',
  borderRight: '8px solid transparent',
  borderTop: `8px solid ${theme.palette.common.white}`,
  zIndex: -1
}));
